import React, { type FC } from 'react';

import type { BreadcrumbsProps } from '../src/Breadcrumbs.tsx';
import { Breadcrumbs as BreadcrumbsComponent } from '../src/Breadcrumbs.tsx';

export const BreadcrumbsNonLoadable: FC<BreadcrumbsProps> = (props) => (
	<BreadcrumbsComponent {...props} />
);
